/*
 * @作者: jiguijian(jiguijian@hztianque.com)
 * @描述: drugVisit 请求模块
 * @创建日期: 2020-05-13 09:13:11
 */

import { http } from '@/lib/http'
// 列表
export const getQueryDatalist = async (payload) => {
  return await http.post('/project/queryProjectListByCondition', payload)
}
// 下拉内容
export const getselectList = async (payload) => {
  return await http.get('/category/findByLevel', payload)
}
// 方案保存
export const save = async (payload) => {
  return await http.post('/project/save', payload)
}
// 方案修改
export const update = async (payload) => {
  return await http.post('/project/update', payload)
}
// 方案详情
export const details = async (payload) => {
  return await http.get('/project/findDetailById', payload)
}
//删除
export const deleteById = async (payload) => {
  return await http.get('/project/deleteById', payload)
}